module.exports = __webpack_public_path__ + "img/mandala3.171afbe7.jpg";